import { isDevelopmentOrMockMode } from "../utils/utils";

const environment = import.meta.env;

async function sendApiRequest(
  path: string,
  requestMethod: "POST" | "GET" | "DELETE",
  controllerVersion = 1,
  signal?: AbortSignal | null,
  requestBody?: BodyInit,
  contentType: string = "application/json"
) {
  let url = `https://${window.location.host}`;

  if (isDevelopmentOrMockMode()) {
    url = `http://${environment.VITE_BFF_HOST}`;
  }

  const headers = new Headers();
  headers.set("Content-Type", contentType);
  headers.set("request-step-id", environment.VITE_STEP_ID);

  const requestOptions: RequestInit = {
    method: requestMethod,
    headers,
    body: requestBody,
    signal,
    cache: "no-cache",
  };

  const apiUrl = `${url}${environment.VITE_BFF_ROUTE_PREFIX}/api/v${controllerVersion}/${path}`;

  return fetch(apiUrl, requestOptions).then(async (response) => {
    const responseText = await response.text();

    let responseJson;
    if (responseText.length !== 0) {
      responseJson = JSON.parse(responseText);
    }

    if (response.ok) {
      return responseJson || Promise.resolve(response.statusText);
    }

    const errorCode = responseJson?.fullCode ?? response.status.toString();

    return Promise.reject(new Error(errorCode));
  });
}

export default sendApiRequest;
